"use client";

import { ChevronLeft } from "lucide-react";

import { useRouter } from "@/i18n/navigation";

interface RecipeBackButtonProps {
  className?: string;
  /** Where to go if there's no history to go back to (deep-link landing). */
  fallbackHref?: string;
}

// Recipe detail back button. Prefers the actual prior route via
// router.back() so users land back on Recipes / favorites scope /
// the Discover query they came from. Falls back to fallbackHref
// (default /discover) when there's no prior history entry — direct
// link landings, opens-in-new-tab, etc.
export function RecipeBackButton({ className, fallbackHref = "/discover" }: RecipeBackButtonProps) {
  const router = useRouter();

  const handleClick = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back();
    } else {
      router.replace(fallbackHref);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={
        className ??
        "inline-flex size-9 cursor-pointer items-center justify-center rounded-full bg-black/50 text-white backdrop-blur-sm transition-colors hover:bg-black/70"
      }
    >
      <ChevronLeft className="size-5" aria-hidden />
    </button>
  );
}
